<template>
  <div class="row">
    <div class="col-sm-12" :class="{ 'col-md-6 col-xl-9': showAdvanced }">
      <div class="w-100">
        <h1>Licence Groups</h1>

        <licence-group-toolbar @advanced-search="toggleAdvancedSearch" />

        <licence-group-search-table ref="licenceGroupTable" />
      </div>
    </div>
    <div v-if="showAdvanced" class="col-sm-12 col-md-6 col-xl-3">
      <licence-group-search-advanced @error-message-changed="showErrorMessage" @reset-requested="reset"
        @close="toggleAdvancedSearch" />
    </div>
  </div>
</template>

<script>
import LicenceGroupSearchAdvanced from './LicenceGroupSearchAdvanced.vue';
import LicenceGroupSearchTable from './LicenceGroupSearchTable.vue';
import LicenceGroupToolbar from './LicenceGroupToolbar.vue';

export default {
  name: 'LicenceGroupList',
  components: {
    LicenceGroupSearchAdvanced,
    LicenceGroupSearchTable,
    LicenceGroupToolbar,
  },
  emits: ['toggle-advanced-search-license-groups'],
  data() {
    return {
      showAdvanced: false,
    };
  },
  methods: {
    toggleAdvancedSearch() {
      this.showAdvanced = !this.showAdvanced;
      this.emitter.emit('toggle-advanced-search-license-groups', this.showAdvanced);
    },
    showErrorMessage(msg) {
      this.$refs.licenceGroupTable.changeErrorMessage(msg);
    },
    reset() {
      this.$refs.licenceGroupTable.reset();
    },
  },
};
</script>
